import type { FC } from 'react';
import { Stack } from '@mui/material';

import ClearCartField from './ClearCartField';
import LanguageSelectorField from './LanguageSelectorField';
import MakeZipField from './MakeZipField';
import ShoppingCart from './ShoppingCart';

export const SHOPPING_CART_BANNER_TEST_ID = 'shopping-cart-banner';

export const ShoppingCartBanner: FC = () => (
  <Stack
    direction="row"
    data-test-id={SHOPPING_CART_BANNER_TEST_ID}
    sx={{
      width: '100%',
    }}
  >
    <ShoppingCart />

    <Stack
      direction="row"
      sx={{
        flexGrow: 1,
        height: '6rem',
      }}
    >
      <LanguageSelectorField />

      <ClearCartField />

      <MakeZipField />
    </Stack>
  </Stack>
);

export default ShoppingCartBanner;
